module.exports = __webpack_public_path__ + "img/stock7.9c5ad9a5.png";